import type { MasterProfile, OrderRow } from "../../../types";
import type { TransportHistoryRow } from "./types";

const INVALID_DATE_MESSAGE = "Няма дата";
const DAY_MS = 1000 * 60 * 60 * 24;

export const daysBetween = (left: Date, right: Date): number =>
    Math.round((right.getTime() - left.getTime()) / DAY_MS);

export const formatDate = (value?: string): string => {
    if (!value) return INVALID_DATE_MESSAGE;

    const date = new Date(value);
    if (isNaN(date.getTime())) return value;

    return date.toLocaleDateString("bg-BG");
};

export const formatDaysInterval = (days: number | null): string => {
    if (days === null) return "Първа заявка";
    if (days === 0) return "Същия ден";
    return `${days} дни`;
};

export const normalizeValue = (value?: string): string =>
    (value ?? "").trim().toLocaleLowerCase("bg-BG");

export const normalizeBusinessKey = (value?: string): string =>
    normalizeValue(value)
        .replace(/["'`„“.,/-]/g, " ")
        .replace(/\b(еоод|оод|еад|ад|ет|сд|кд)\b/g, " ")
        .replace(/\s+/g, " ")
        .trim();

export const parseOrderDate = (value?: string): Date | null => {
    if (!value) return null;

    const normalizedValue = value.includes(" ") ? value.replace(" ", "T") : value;
    const parsedDate = new Date(normalizedValue);

    if (!isNaN(parsedDate.getTime())) {
        return parsedDate;
    }

    const fallbackDate = new Date(value);

    return isNaN(fallbackDate.getTime()) ? null : fallbackDate;
};

export function buildTransportHistoryFromOrders(orders: OrderRow[]): TransportHistoryRow[] {
    const seen = new Set<string>();
    const rows: TransportHistoryRow[] = [];

    for (const order of orders) {
        const hasTransport = Boolean(
            order.deliveryTransport?.trim()
            || order.deliveryDriver?.trim()
            || order.deliveryBus?.trim()
            || order.deliveryRoute?.trim()
        );

        if (!hasTransport) {
            continue;
        }

        const transportDate = order.createdAt?.trim() || "";
        const bus = order.deliveryBus?.trim() || order.deliveryTransport?.trim() || "";
        const route = order.deliveryRoute?.trim() || "";
        const note = order.deliveryDriver?.trim() || "";
        const dedupeKey = `${transportDate}|${bus}|${route}|${note}`;

        if (seen.has(dedupeKey)) {
            continue;
        }

        seen.add(dedupeKey);
        rows.push({
            id: rows.length + 1,
            transportDate,
            clientName: order.customer?.trim() || "",
            location: order.location?.trim() || "",
            bus,
            route,
            note,
            clientCode: order.orderNumber?.trim() || "",
        });
    }

    return rows.sort((left, right) => {
        const leftTime = new Date(left.transportDate).getTime();
        const rightTime = new Date(right.transportDate).getTime();

        if (Number.isFinite(leftTime) && Number.isFinite(rightTime) && leftTime !== rightTime) {
            return rightTime - leftTime;
        }

        return right.id - left.id;
    });
}

export const buildFallbackProfile = (profileId: string, customer: string): MasterProfile => ({
    loyaltyCard: "",
    profileId,
    customer: customer || profileId,
    channels: "",
    consent: "",
    lastOrder: "",
    lifetimeValue: 0,
    status: "Частичен",
    preferredStore: "",
    Phone: "",
    email: "",
    Discount: "",
});
